function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M31 0C13.9 0 0 13.9 0 31s13.9 31 31 31c8.5 0 16.4-3.3 22-9l-5.6-5.6c-4.2 4.2-10 6.8-16.5 6.8C18.1 54.2 7.7 43.9 7.7 31S18.1 7.8 30.9 7.8c6.4 0 12 2.8 16.2 7.1l-8.4 8.4h23.2V0l-9.2 9.2C47.1 3.6 39.4 0 31 0z"
});

function SvgRestart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 62 62"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHg9IjAiIHk9IjAiIHZpZXdCb3g9IjAgMCA2MiA2MiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHBhdGggZD0iTTMxIDBDMTMuOSAwIDAgMTMuOSAwIDMxczEzLjkgMzEgMzEgMzFjOC41IDAgMTYuNC0zLjMgMjItOWwtNS42LTUuNmMtNC4yIDQuMi0xMCA2LjgtMTYuNSA2LjhDMTguMSA1NC4yIDcuNyA0My45IDcuNyAzMVMxOC4xIDcuOCAzMC45IDcuOGM2LjQgMCAxMiAyLjggMTYuMiA3LjFsLTguNCA4LjRoMjMuMlYwbC05LjIgOS4yQzQ3LjEgMy42IDM5LjQgMCAzMSAweiIvPjwvc3ZnPg==";
export { SvgRestart as ReactComponent };